export default {
  title: 'Zahlungs-Gateway',
  description:
    'Ihre eigenen Zahlungs-Gateways für Online-Bestellungen. Der gesamte Bestellbetrag wird auf Ihrem Gateway-Konto abgerechnet; die Auszahlung an Ihre Restaurants erfolgt durch Sie.',
  toasts: {
    load_error: 'Gateway-Einrichtung konnte nicht geladen werden',
  },
  not_enabled: {
    title: 'Spreedly ist für Ihr Konto noch nicht aktiviert',
    description:
      'Lokale Zahlungs-Gateways werden von FoodAmigos aktiviert. Bitte wenden Sie sich an Ihren FoodAmigos-Ansprechpartner.',
  },
  processor_mode: {
    title: 'Wer wickelt die Zahlungen ab?',
    description:
      'Dies wird einmal für alle Ihre Restaurants festgelegt. Sie können später in den Partnereinstellungen wechseln, solange kein Restaurant live ist.',
    save: 'Speichern',
    options: {
      platform: {
        title: 'FoodAmigos wickelt die Zahlungen ab',
        badge: 'Empfohlen',
        description:
          'Wir übernehmen das Zahlungskonto, die Verifizierung und die Auszahlungen. Jedes Restaurant ergänzt seine Geschäftsdaten und durchläuft eine kurze Prüfung bei Adyen.',
        methods: 'Akzeptiert: {{methods}}',
      },
      provider: {
        title: 'Ich bringe meinen eigenen Anbieter mit',
        description:
          'Verbinden Sie einen Zahlungsanbieter, den Sie bereits nutzen. Auszahlungen, Gebühren und Verifizierung bleiben bei diesem Anbieter.',
      },
    },
    payment_methods: {
      card: 'Karte',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Pay by Bank',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos wickelt die Zahlungen für alle Ihre Restaurants ab.',
      provider: 'Ihre Restaurants nehmen Zahlungen über Ihre eigenen Anbieter entgegen.',
    },
    confirm_choice: {
      title: 'Zahlungsabwicklung auf „{{mode}}“ festlegen?',
      description:
        'Dies gilt für jedes Ihrer Restaurants. Sie können später in den Partnereinstellungen wechseln, aber nur solange kein Restaurant live ist.',
      confirm: 'Speichern und fortfahren',
    },
    switch: {
      link: 'Zahlungsabwicklung ändern',
      confirm: {
        confirm: 'Wechseln',
        provider: {
          title: 'Zu Ihrem eigenen Anbieter wechseln?',
          description: 'Restaurants, die FoodAmigos-Zahlungen nutzen, werden wieder auf „Nicht eingerichtet“ gesetzt.',
        },
        platform: {
          title: 'Zu FoodAmigos-Zahlungen wechseln?',
          description: 'Restaurants, die Ihre eigenen Anbieter nutzen, werden wieder auf „Nicht eingerichtet“ gesetzt.',
        },
      },
      unavailable: {
        title: 'FoodAmigos-Zahlungen sind noch nicht verfügbar',
        description: 'FoodAmigos-Zahlungen sind in Ihrem Land noch nicht verfügbar.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Wenden Sie sich an FoodAmigos, um dies zu ändern',
        description_one:
          '{{count}} Restaurant nimmt bereits Zahlungen entgegen. Ein Wechsel würde bedeuten, dass es sich beim neuen Anbieter neu registrieren muss. Unser Team plant das gemeinsam mit Ihnen.',
        description_other:
          '{{count}} Restaurants nehmen bereits Zahlungen entgegen. Ein Wechsel würde bedeuten, dass sie sich beim neuen Anbieter neu registrieren müssen. Unser Team plant das gemeinsam mit Ihnen.',
        confirm: 'E-Mail an FoodAmigos',
        subject_one: 'Zahlungsabwicklung ändern ({{count}} Restaurant live)',
        subject_other: 'Zahlungsabwicklung ändern ({{count}} Restaurants live)',
      },
    },
    toasts: {
      load_error: 'Zahlungseinrichtung konnte nicht geladen werden',
      save_error: 'Zahlungseinrichtung konnte nicht gespeichert werden',
      chosen: 'Zahlungsabwicklung gespeichert',
      switched: 'Zahlungsabwicklung gewechselt',
    },
  },
  gateways: {
    title: 'Verbundene Anbieter',
    empty: 'Verbinden Sie den Zahlungsanbieter, den Sie bereits nutzen. Ihre Restaurants werden darunter angelegt.',
    connect_another: 'Anbieter verbinden',
    support_hint:
      'Sobald ein Restaurant Live-Zahlungen annimmt, planen wir einen Anbieterwechsel gemeinsam – schreiben Sie an {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Zahlungsgateway',
      platform_adyen: 'FoodAmigos Payments',
    },
    statuses: {
      connected: 'Verbunden',
      disconnected: 'Getrennt',
      needs_attention: 'Handlungsbedarf',
    },
    issue: {
      connect_not_enabled: {
        title: 'Stripe Connect ist im Konto hinter {{name}} nicht aktiviert',
        description:
          'Stripe kann keine Konten für Ihre Restaurants anlegen, solange Connect nicht aktiviert ist. Aktivieren Sie es in Ihrem Stripe-Dashboard und prüfen Sie es hier anschließend erneut.',
      },
      account_restricted: {
        title: 'Stripe hält neue Konten unter {{name}} zurück',
        description:
          'Stripe hat das Anlegen verbundener Konten für Ihr Konto vorübergehend eingeschränkt. Melden Sie sich in Ihrem Stripe-Dashboard an, bestätigen Sie, dass Sie diese Konten anlegen wollten, und prüfen Sie es hier anschließend erneut.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe verlangt für {{name}} zuerst die Übernahme der Verlusthaftung',
        description:
          'Ihre Stripe-Plattform hat die Haftung für negative Salden auf den Konten Ihrer Restaurants noch nicht übernommen, daher legt Stripe diese Konten nicht an. Öffnen Sie in Ihrem Stripe-Dashboard Einstellungen → Connect → Plattformprofil, schließen Sie die Bestätigung der Verlusthaftung ab und prüfen Sie es hier anschließend erneut. Den Hinweis von Stripe zu Accounts v2 unten können Sie ignorieren.',
      },
      account_creation_refused: {
        title: 'Stripe hat das Anlegen eines Restaurantkontos unter {{name}} abgelehnt',
        description:
          'Prüfen Sie die folgende Meldung in Ihrem Stripe-Dashboard und prüfen Sie es hier anschließend erneut.',
      },
      key_invalid: {
        title: 'Stripe akzeptiert den für {{name}} verbundenen Schlüssel nicht mehr',
        description:
          'Der Schlüssel wurde erneuert, widerrufen oder ist abgelaufen. Erstellen Sie in Ihrem Stripe-Dashboard einen neuen Schlüssel und ersetzen Sie ihn hier.',
      },
      key_access_limited: {
        title: 'Stripe hat den für {{name}} verbundenen Schlüssel eingeschränkt',
        description:
          'Ein eingeschränkter Schlüssel kann keine Überweisungen oder Auszahlungen für Ihre Restaurants ausführen. Öffnen Sie in Ihrem Stripe-Dashboard Entwickler → API-Schlüssel, stellen Sie den vollen Zugriff des Schlüssels wieder her und prüfen Sie hier erneut – oder erneuern Sie den Schlüssel und ersetzen Sie ihn hier.',
      },
      provider_said: 'Meldung von Stripe: „{{message}}“',
      hint: 'Bis das behoben ist, können die mit diesem Anbieter verbundenen Restaurants keine Online-Zahlungen annehmen.',
      open_stripe: 'Stripe-Dashboard öffnen',
      check_again: 'Erneut prüfen',
      replace_key: 'Schlüssel ersetzen',
      cleared: 'Stripe nimmt Ihre Restaurants wieder an',
      still_blocked: 'Stripe lehnt weiterhin ab – siehe Meldung oben',
    },
    refused: {
      provider_said: 'Meldung von {{name}}: „{{message}}“',
      reference: 'Referenz:',
      contact_support: 'Support per E-Mail kontaktieren',
      support_subject: 'Verbindung zum Zahlungsanbieter abgelehnt: {{name}} (Ref. {{reference}})',
      account_in_test_mode: {
        action: 'Schalten Sie in Authorize.Net unter {{path}} den Testmodus aus und versuchen Sie es dann erneut.',
        open: 'Authorize.Net öffnen',
      },
      processor_not_configured: {
        action:
          'Wenden Sie sich an Ihren Merchant Service Provider, also das Unternehmen, das Ihr Authorize.Net-Konto eröffnet hat, und bitten Sie ihn, die Einrichtung beim Zahlungsabwickler abzuschließen. Neue Schlüssel ändern daran nichts. Versuchen Sie es danach erneut.',
        action_card_connect:
          'Bitten Sie den CardConnect-Support, Card-not-present-Autorisierungen (E-Commerce) für diese Merchant ID freizuschalten. Neue API-Zugangsdaten ändern daran nichts. Versuchen Sie es danach erneut.',
      },
    },
    table: {
      primary_tag: 'Standard',
      live_count_one: '{{count}} nimmt Zahlungen an',
      live_count_other: '{{count}} nehmen Zahlungen an',
      attention_count_one: '{{count}} braucht Aufmerksamkeit',
      attention_count_other: '{{count}} brauchen Aufmerksamkeit',
      columns: {
        methods: 'Lokale Zahlungsarten',
        connection: 'Anbieter',
        status: 'Status',
        restaurants: 'Restaurants',
      },
      methods_count: '{{enabled}} von {{capable}} aktiv',
    },
    picker: {
      recommended: 'Empfohlen',
      connect: 'Verbinden',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          'Nutzen Sie Ihr eigenes Stripe-Konto. Jedes Restaurant durchläuft das Onboarding von Stripe; Auszahlungen und Gebühren bleiben bei Stripe.',
        already_connected: 'Bereits verbunden. Über „Zugangsdaten bearbeiten“ in der Liste ersetzen Sie den Schlüssel.',
        already_connected_short: 'Bereits verbunden.',
      },
      stripe_direct: {
        title: 'Stripe (direkt)',
        description: 'Rechnen Sie alle Restaurants über ein einziges Stripe-Konto von Ihnen ab.',
        unavailable: 'In Ihrer Region noch nicht verfügbar.',
      },
      paypal: {
        direct: 'Bieten Sie PayPal über Ihr eigenes PayPal-Geschäftskonto an.',
        braintree: 'Nehmen Sie Karten, PayPal und Venmo über Ihr Braintree-Konto an.',
      },
      other: {
        title: 'Weitere Anbieter',
        search: 'Anbieter suchen',
        loading: 'Anbieter werden geladen…',
        no_match: 'Kein Anbieter namens „{{query}}“.',
        none_available: 'In Ihrer Region sind noch keine weiteren Anbieter verfügbar.',
        load_error: 'Die Anbieterliste konnte nicht geladen werden.',
        retry: 'Erneut versuchen',
        pinned_match: 'Diesen Anbieter finden Sie oben.',
      },
      not_listed: {
        action: 'Mein Anbieter ist nicht aufgeführt',
        subject: 'Anfrage Zahlungsanbieter: {{query}}',
      },
      use_foodamigos: {
        no_account: 'Ich habe bei keinem dieser Anbieter ein Konto',
        switch: 'Zu FoodAmigos Payments wechseln',
      },
    },
    orchestrated: {
      title: '{{name}} verbinden',
      replace_title: 'Zugangsdaten für {{name}} ersetzen',
      intro:
        'Geben Sie die Zugangsdaten aus Ihrem {{name}}-Konto ein. Wir prüfen sie bei {{name}}, bevor etwas gespeichert wird.',
      auth_mode: 'Wie Sie sich bei diesem Anbieter anmelden',
      checking: 'Prüfung bei {{name}}…',
      paypal_direct: {
        intro:
          'Fügen Sie die Client-ID und das Secret der PayPal-REST-App ein, über die Ihre Restaurants PayPal annehmen sollen. Wir prüfen sie bei PayPal, bevor etwas gespeichert wird.',
        client_id: 'Client-ID',
        secret: 'Secret',
        hint: 'PayPal Developer Dashboard → Apps & Credentials, Tab „Live“. Verwenden Sie eine REST-App Ihres Geschäftskontos.',
        hint_sandbox:
          'PayPal Developer Dashboard → Apps & Credentials, Tab „Sandbox“: Diese Umgebung akzeptiert nur Sandbox-Apps.',
      },
      braintree: {
        intro:
          'Geben Sie die API-Schlüssel Ihres Braintree-Kontos ein. PayPal und Venmo funktionieren, sobald sie im Braintree Control Panel verknüpft sind — Sie aktivieren sie danach pro Verbindung.',
      },
      authorize_net: {
        intro:
          'Geben Sie die API Login ID und den Transaction Key Ihres Authorize.Net-Kontos ein. Wir prüfen sie mit einer kleinen Testautorisierung: In Ihrem Authorize.Net-Transaktionsprotokoll erscheint sie als abgelehnte Zahlung über 1,00 $, es wird kein Geld bewegt. Das Konto muss im Live-Modus sein, denn im Testmodus lehnt Authorize.Net jede echte Zahlung ab.',
        hint: 'Sie finden beide im Authorize.Net Merchant Interface unter {{path}}.',
      },
      card_connect: {
        intro:
          'Geben Sie Merchant ID, Benutzername und Passwort Ihres Live-CardConnect-Kontos (CardPointe) ein. Wir prüfen sie mit einer Autorisierung über 1,00, die wir sofort stornieren: In Ihrem CardPointe-Transaktionsprotokoll erscheint sie als abgelehnte oder stornierte Zahlung über 1,00, es wird kein Geld bewegt.',
      },
      stripe_direct: {
        intro:
          'Fügen Sie den geheimen Schlüssel oder einen eingeschränkten Schlüssel des Stripe-Kontos ein, über das alle Restaurants abrechnen sollen. Den Webhook, den Stripe benötigt, richten wir für Sie ein.',
        secret_key: 'Geheimer oder eingeschränkter Stripe-Schlüssel',
        hint: 'Stripe → Entwickler → API-Schlüssel. Beginnt mit sk_ (geheim) oder rk_ (eingeschränkt). Ein eingeschränkter Schlüssel braucht Schreibzugriff auf Charges and Refunds, Customers, PaymentIntents, PaymentMethods, SetupIntents, Tokens und Webhook Endpoints. Ein Publishable Key wird nicht benötigt.',
        prefix_error: 'Geheime Stripe-Schlüssel beginnen mit sk_, eingeschränkte Schlüssel mit rk_.',
      },
      connected: {
        title: '{{name}} ist verbunden.',
        description:
          'Wir verwenden diese Zugangsdaten für alle Ihre Restaurants. Jedes Restaurant ergänzt weiterhin seine Unternehmensdaten.',
      },
      errors: {
        generic: '{{name}} konnte nicht verbunden werden',
      },
    },
    stripe: {
      title: 'Stripe Connect verbinden',
      rotate_title: 'Stripe-Connect-Schlüssel ersetzen',
      rotate_intro:
        'Fügen Sie einen neuen geheimen Schlüssel und Publishable Key aus demselben Stripe-Konto ein. Ihre Restaurants bleiben verbunden.',
      intro:
        'Fügen Sie den geheimen Schlüssel und den Publishable Key Ihres Stripe-Kontos ein. Beide finden Sie unter Developers → API keys.',
      verify_and_connect: 'Prüfen und verbinden',
      checking: 'Wird mit Stripe geprüft…',
      secret_key: {
        label: 'Geheimer Schlüssel',
        hint: 'Stripe → Developers → API keys. Beginnt mit sk_.',
        prefix_error: 'Geheime Schlüssel beginnen mit sk_. Das sieht nach einem anderen Schlüsseltyp aus.',
      },
      use_restricted_key: 'Stattdessen einen eingeschränkten Schlüssel verwenden',
      use_secret_key: 'Stattdessen den geheimen Schlüssel verwenden',
      restricted_key: {
        label: 'Eingeschränkter API-Schlüssel',
        hint: 'Stripe → Developers → API keys → Create restricted key. Beginnt mit rk_. Richten Sie ihn wie oben beschrieben ein.',
        prefix_error: 'Eingeschränkte Schlüssel beginnen mit rk_. Das sieht nach einem anderen Schlüsseltyp aus.',
      },
      publishable_key: {
        label: 'Publishable Key',
        hint: 'Auf derselben Stripe-Seite. Beginnt mit pk_. Ihre Storefronts benötigen ihn für Kartenzahlungen.',
        prefix_error: 'Publishable Keys beginnen mit pk_.',
        mode_mismatch:
          'Ein Schlüssel ist ein Live-Schlüssel, der andere ein Test-Schlüssel. Beide müssen aus demselben Stripe-Modus stammen.',
      },
      name: {
        label: 'Name dieser Verbindung',
        hint: 'Optional. Wird überall dort angezeigt, wo dieser Anbieter aufgeführt ist.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'So erstellen Sie diesen Schlüssel',
        start_blank:
          'Wenn Stripe fragt, wie Sie den Schlüssel verwenden werden, wählen Sie „{{option}}“. Dann stehen zunächst alle Berechtigungen auf „{{none}}“.',
        intro:
          'Stellen Sie anschließend den Schalter in der Kopfzeile jedes dieser Bereiche ein. Er setzt alle Berechtigungen des Bereichs, Sie müssen sie also nicht einzeln durchgehen.',
        rows_checked: 'Wir prüfen: {{rows}}',
        secret_key_hint:
          'Lassen Sie alle anderen Bereiche auf „{{none}}“. Für einen geheimen Schlüssel ist nichts davon nötig.',
        open_stripe: 'Ihre Stripe-API-Schlüssel öffnen',
      },
      login_setting: {
        title: 'Stripe-Login für Ihre Restaurants ausschalten',
        description:
          'Öffnen Sie in Ihrem Stripe-Dashboard Einstellungen → Connect → Auszahlungen → Externe Konten und schalten Sie „{{setting}}“ aus. Solange die Einstellung aktiv ist, lässt Stripe jedes Restaurant beim Onboarding einen Stripe-Login mit Telefonnummer anlegen und fragt bei jedem weiteren Aufruf einen SMS-Code ab. Wer dieses Telefon nicht hat, kommt nicht weiter.',
        bank_details: 'Es geht nichts verloren: Restaurants geben ihre Bankverbindung in unserem eigenen Formular ein.',
        open_stripe: 'Diese Stripe-Einstellung öffnen',
      },
      errors: {
        generic: 'Stripe konnte nicht erreicht werden',
      },
    },
    default_choice: {
      label: 'Als Standard für Restaurants verwenden',
      hint: 'Neue Restaurants und Restaurants ohne Anbieter werden automatisch damit verknüpft. Lassen Sie das Feld leer, um für jedes Restaurant selbst einen Anbieter zu wählen.',
    },
    manage: {
      payment_methods: 'Zahlungsarten',
      edit_credentials: 'Zugangsdaten bearbeiten',
      edit_credentials_unavailable: 'Zugangsdaten bearbeiten (dieser Anbieter ist derzeit nicht verfügbar)',
      set_primary: 'Als Standard für neue Restaurants festlegen',
      clear_primary: 'Nicht mehr als Standard für neue Restaurants verwenden',
      rename: {
        action: 'Verbindung umbenennen',
        title: 'Diese Verbindung umbenennen',
        confirm: 'Speichern',
      },
      disconnect: {
        action: 'Trennen',
        title: '{{name}} trennen?',
        confirm: 'Trennen',
        warning_one: '{{count}} Restaurant ist damit verknüpft und wird wieder auf „Nicht eingerichtet“ gesetzt.',
        warning_other: '{{count}} Restaurants sind damit verknüpft und werden wieder auf „Nicht eingerichtet“ gesetzt.',
        live: {
          title_one: 'Online-Zahlungen werden für {{count}} Live-Restaurant pausiert',
          title_other: 'Online-Zahlungen werden für {{count}} Live-Restaurants pausiert',
          description:
            'Sobald Sie trennen, können deren Gäste nicht mehr online bezahlen. Jedes Restaurant wird wieder auf „Nicht eingerichtet“ gesetzt, bis Sie es mit einem anderen Anbieter verknüpfen.',
          refunds:
            'Bestellungen, die bereits über diesen Anbieter bezahlt wurden, können nicht mehr über FoodAmigos erstattet werden.',
          pause_one: 'Online-Zahlungen für dieses Restaurant pausieren',
          pause_other: 'Online-Zahlungen für diese {{count}} Restaurants pausieren',
          confirm: 'Trennen und Zahlungen pausieren',
        },
      },
      remove: {
        action: 'Aus der Liste entfernen',
        title: '{{name}} entfernen?',
        description:
          'Der Anbieter ist bereits getrennt und wird von keinem Restaurant genutzt. Er wird in dieser Liste nicht mehr angezeigt.',
        confirm: 'Entfernen',
      },
    },
    payment_methods: {
      title: 'Zahlungsarten für {{name}}',
      description:
        'Wählen Sie die lokalen Zahlungsarten, die Ihre Restaurants über diesen Anbieter anbieten. Jede erscheint nur dort, wo die Währung des Restaurants passt.',
      save: 'Speichern',
      publishable_key: {
        label: 'Veröffentlichbarer Stripe-Schlüssel',
        hint: 'Stripe braucht ihn, um das Zahlungsformular anzuzeigen. Sie finden ihn im Stripe-Dashboard unter Entwickler → API-Schlüssel.',
        invalid: 'Ein veröffentlichbarer Schlüssel beginnt hier mit {{prefix}}.',
        clear_to_save:
          'Er stammt aus dem anderen Stripe-Modus. Löschen Sie ihn, um mit allen lokalen Zahlungsarten aus zu speichern.',
      },
      on_other_connection: 'bereits für {{connection}} aktiviert',
      other_currency: 'nicht in {{currency}} verfügbar',
      delivery_only: '{{name}} (nur bei Lieferbestellungen — benötigt die Adresse der Kundschaft)',
      invite_only:
        '{{name}} (bei Stripe nur auf Einladung — beantragen Sie zuerst den Zugang in Ihrem Stripe-Dashboard, sonst lehnt Stripe jede Zahlung ab)',
      also_enable: {
        stripe:
          'Aktivieren Sie dieselben Zahlungsarten im Stripe-Dashboard unter Einstellungen → Zahlungsmethoden, sonst lehnt Stripe sie ab.',
        provider: 'Ihr Vertrag mit diesem Anbieter muss die hier aktivierten Zahlungsarten umfassen.',
        braintree:
          'Verknüpfen Sie PayPal und Venmo zuerst im Braintree Control Panel unter Settings → Processing, sonst lehnt Braintree sie ab. Venmo ist für US-Restaurants, die in Dollar abrechnen.',
        paypal_direct: 'PayPal-Zahlungen gehen auf dieses PayPal-Geschäftskonto. Für Venmo verbinden Sie Braintree.',
      },
    },
    actions: {
      cancel: 'Abbrechen',
    },
    toasts: {
      load_error: 'Die verbundenen Anbieter konnten nicht geladen werden',
      credentials_replaced: 'Zugangsdaten ersetzt',
      save_error: 'Speichern fehlgeschlagen',
      connected: 'Stripe Connect ist verbunden',
      renamed: 'Verbindung umbenannt',
      primary_set: 'Standardanbieter aktualisiert',
      primary_cleared:
        'Standardanbieter entfernt. Neue Restaurants werden erst mit einem Anbieter verbunden, wenn Sie einen auswählen.',
      disconnected: 'Anbieter getrennt',
      removed: 'Anbieter entfernt',
      payment_methods_saved: 'Zahlungsarten gespeichert',
    },
  },
  restaurants: {
    title: 'Restaurants',
    description: 'Wie weit jedes Restaurant mit Online-Zahlungen ist.',
    search: 'Restaurants suchen',
    filters: {
      all: 'Alle ({{count}})',
      needs_attention: 'Braucht Aufmerksamkeit ({{count}})',
    },
    empty: 'Noch keine Restaurants.',
    empty_attention: 'Nichts braucht gerade Ihre Aufmerksamkeit.',
    columns: {
      restaurant: 'Restaurant',
      provider: 'Anbieter',
      status: 'Status',
      action: 'Aktion',
    },
    no_provider: '—',
    foodamigos_payments: 'FoodAmigos Payments',
    groups: {
      not_set_up: 'Nicht eingerichtet',
      business_details_missing: 'Unternehmensangaben fehlen',
      hosted_not_finished: '{{provider}}-Formular nicht abgeschlossen',
      hosted_not_finished_generic: 'Anbieterformular nicht abgeschlossen',
      waiting_for_provider: 'Wartet auf Anbieter',
      action_needed: 'Handlung erforderlich',
      payments_live: 'Zahlungen aktiv',
      online_payments_off: 'Online-Zahlungen aus',
      waiting_for_partner: 'Wartet auf Sie',
    },
    link_expired: 'Link abgelaufen',
    actions: {
      set_up: 'Einrichten',
      change: 'Ändern',
      unlink: 'Trennen',
      remind: 'Inhaber erinnern',
      reminded: 'Erinnert · wieder ab {{time}}',
      start_over: 'Stripe-Einrichtung neu starten',
    },
    assign: {
      title: 'Welchen Anbieter soll {{name}} nutzen?',
      label: 'Anbieter',
      confirm: 'Speichern',
      cancel: 'Abbrechen',
      primary: 'Standard',
      none: 'Verbinden Sie zuerst einen Anbieter.',
    },
    unlink: {
      title: '{{name}} von {{provider}} trennen?',
      title_generic: '{{name}} von seinem Anbieter trennen?',
      description:
        'Das Restaurant wird wieder auf „Nicht eingerichtet“ gesetzt, damit Sie den richtigen Anbieter wählen können. Der Anbieter bleibt für Ihre anderen Restaurants verbunden.',
      confirm: 'Trennen',
    },
    pause: {
      title: 'Online-Zahlungen für {{name}} werden pausiert',
      description:
        'Gäste können erst wieder online bezahlen, wenn das Restaurant erneut bei einem Anbieter eingerichtet und verifiziert ist.',
      refunds:
        'Bestellungen, die bereits über den aktuellen Anbieter bezahlt wurden, können nicht mehr über FoodAmigos erstattet werden.',
      confirm: 'Online-Zahlungen für dieses Restaurant pausieren',
    },
    start_over: {
      title: 'Stripe-Einrichtung von {{name}} neu starten?',
      points: {
        not_used: 'Das aktuelle Stripe-Konto ({{account}}) wird für dieses Restaurant nicht mehr verwendet.',
        kept: 'Das Konto wird nicht gelöscht: Es bleibt in Ihrem Stripe, wo Sie es ablehnen können.',
        fresh:
          'Das nächste „Weiter“ beginnt wieder auf der ersten Seite von Stripe, und es kann eine andere E-Mail-Adresse verwendet werden.',
        paused:
          'Nimmt das Restaurant Online-Zahlungen an, werden diese pausiert, bis die neue Einrichtung abgeschlossen ist.',
      },
      confirm: 'Neu starten',
      blocked: {
        received_payments:
          'Das Stripe-Konto dieses Restaurants hat bereits Zahlungen erhalten, deshalb kann die Einrichtung nicht neu gestartet werden. Wenden Sie sich an den Support, um es zu ändern.',
        partner_action_needed: 'Beheben Sie zuerst das Problem, das bei Ihrem Stripe Connect angezeigt wird.',
      },
    },
    toasts: {
      load_error: 'Ihre Restaurants konnten nicht geladen werden',
      assigned: 'Anbieter gespeichert',
      assign_error: 'Der Anbieter konnte nicht gespeichert werden',
      unlinked: 'Restaurant getrennt',
      unlink_error: 'Das Restaurant konnte nicht getrennt werden',
      reminded: 'Erinnerung an den Inhaber gesendet',
      remind_error: 'Die Erinnerung konnte nicht gesendet werden',
      cooling_down: 'Der Inhaber wurde heute bereits erinnert',
      started_over: 'Stripe-Einrichtung neu gestartet',
      start_over_error: 'Die Stripe-Einrichtung konnte nicht neu gestartet werden',
    },
  },
  footer: {
    text: 'Ihre FoodAmigos-Servicegebühr wird Ihnen berechnet, unabhängig davon, welchen Anbieter ein Restaurant nutzt.',
    link: 'Zur Abrechnung',
  },
};
